import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Comment } from '../models/Comment';

@Injectable()
export class CommentService {
  private baseUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/`;
  constructor(private http: HttpClient) {}

  getByReflex(reflexNo: string): Observable<Comment[]> {
    return this.http.get<Comment[]>(`${this.baseUrl}Comments/reflex/${encodeURIComponent(reflexNo)}`);
  }

  add(reflexNo: string, commentText: string): Observable<Comment> {
    const body = { reflexOrderNo: reflexNo, commentText } as Partial<Comment>;
    return this.http.put<Comment>(`${this.baseUrl}Comments`, body);
  }

  update(comment: Comment): Observable<void> {
    if (!comment.id) throw new Error('Comment id is required');
    return this.http.post<void>(`${this.baseUrl}Comments/${comment.id}`, comment);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}Comments/${id}`);
  }
}
